import { FC } from 'react';

import MessagesHub from '@/views/bot-message/MessagesHub';

interface IMessagesProps {
  token: string;
  botSelectorContent?: React.ReactNode;
}

const Messages: FC<IMessagesProps> = ({ token, botSelectorContent }) => {
  return <MessagesHub token={token} botSelectorContent={botSelectorContent} />;
};

export default Messages;
